// ----------------------------------------------------------------------------
// Quantity Selector Extension (Validate Inventory Quantity Limits)
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

import iamotaEventHandler from 'scripts/helpers/iamota-event-handler';
import translate from 'scripts/helpers/iamota-translate';
import Debug from 'scripts/libs/debug';

// -------------------------------------
// Functionality
// -------------------------------------

var validationRules = {
  out_of_stock: {
    condition_value: (current_quantity, itemData) => {
      var _itemData$variant, _itemData$variant2, _itemData$variant3;
      var inventory_quantity = ((_itemData$variant = itemData.variant) === null || _itemData$variant === void 0 || (_itemData$variant = _itemData$variant.custom) === null || _itemData$variant === void 0 ? void 0 : _itemData$variant.inventory_quantity) || 0;
      var inventory_policy = (_itemData$variant2 = itemData.variant) === null || _itemData$variant2 === void 0 || (_itemData$variant2 = _itemData$variant2.custom) === null || _itemData$variant2 === void 0 ? void 0 : _itemData$variant2.inventory_policy;
      var inventory_management = (_itemData$variant3 = itemData.variant) === null || _itemData$variant3 === void 0 || (_itemData$variant3 = _itemData$variant3.custom) === null || _itemData$variant3 === void 0 ? void 0 : _itemData$variant3.inventory_management;

      // Only apply the rule if inventory is managed by Shopify with a deny policy
      if (inventory_management !== 'shopify' || inventory_policy !== 'deny') {
        return null;
      }
      return inventory_quantity;
    },
    condition_callback: (current_quantity, available_inventory) => available_inventory > 0,
    error_message: (current_quantity, available_inventory, itemData) => translate('Sorry, this item is out of stock.', 'quantity.error.out_of_stock', {
      QUANTITY: current_quantity,
      INVENTORY: available_inventory,
      itemData
    })
  },
  inventory_quantity: {
    condition_value: (current_quantity, itemData) => {
      var _itemData$variant4, _itemData$variant5, _itemData$variant6;
      var inventory_quantity = ((_itemData$variant4 = itemData.variant) === null || _itemData$variant4 === void 0 || (_itemData$variant4 = _itemData$variant4.custom) === null || _itemData$variant4 === void 0 ? void 0 : _itemData$variant4.inventory_quantity) || 0;
      var inventory_policy = (_itemData$variant5 = itemData.variant) === null || _itemData$variant5 === void 0 || (_itemData$variant5 = _itemData$variant5.custom) === null || _itemData$variant5 === void 0 ? void 0 : _itemData$variant5.inventory_policy;
      var inventory_management = (_itemData$variant6 = itemData.variant) === null || _itemData$variant6 === void 0 || (_itemData$variant6 = _itemData$variant6.custom) === null || _itemData$variant6 === void 0 ? void 0 : _itemData$variant6.inventory_management;

      // Only apply the rule if inventory is managed by Shopify with a deny policy
      if (inventory_management !== 'shopify' || inventory_policy !== 'deny') {
        return null;
      }
      return inventory_quantity;
    },
    condition_callback: (current_quantity, available_inventory) => current_quantity <= available_inventory && available_inventory > 0,
    error_message: (current_quantity, available_inventory, itemData) => translate('Sorry, we only have {{ INVENTORY }} left in stock. Please reduce the quantity.', 'quantity.error.not_enough_inventory', {
      QUANTITY: current_quantity,
      INVENTORY: available_inventory,
      itemData
    })
  }
};
iamotaEventHandler.subscribe('iamForm:quantity:validation:init', _ref => {
  var iamFormElement = _ref.iamFormElement,
    validator = _ref.validator;
  var quantityInput = iamFormElement;
  var _loop = function _loop(ruleType) {
    var rule = validationRules[ruleType];
    validator.addField(quantityInput.control, [{
      validator: (current_quantity, fields) => {
        var itemData = quantityInput.getItemData();
        var condition_value = rule.condition_value(current_quantity, itemData);
        var result = condition_value === null || rule.condition_callback(parseInt(current_quantity, 10), condition_value, itemData);
        Debug.extreme("Validating Quantity [".concat(ruleType, "]: ").concat(current_quantity, " vs. ").concat(condition_value, " => ").concat(result ? Debug.colors.bgGreen('Valid') : Debug.colors.bgRed('Invalid')), {
          current_quantity,
          condition_value,
          result,
          itemData,
          fields
        });
        return result;
      },
      errorMessage: (current_quantity, fields) => {
        var itemData = quantityInput.getItemData();
        var condition_value = rule.condition_value(current_quantity, itemData);
        return rule.error_message(current_quantity, condition_value, itemData);
      }
    }], {
      errorsContainer: quantityInput.errorContainer
    });
  };
  for (var ruleType in validationRules) {
    _loop(ruleType);
  }
}, {
  source: "quantity-input--inventory-limits.js"
});